export default __webpack_public_path__ + "static/media/twitter.f573afd4.svg";